export default "__VITE_ASSET__B0hdK_lj__"